import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const GrowDown = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 16 16"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <circle cx={8} cy={8} r={8} fill="#D51A1D" fillOpacity={0.2} />
      <path
        fill="#D51A1D"
        fillRule="evenodd"
        d="M11.81 5.788a.586.586 0 0 1 0 .826L9.314 9.107a.58.58 0 0 1-.898-.086l-.85-1.28-1.774 1.77h.922a.584.584 0 1 1 0 1.169H4.37a.59.59 0 0 1-.586-.585V7.758a.586.586 0 0 1 1.17 0v.934L7.242 6.41a.58.58 0 0 1 .898.086l.851 1.28 1.991-1.986a.585.585 0 0 1 .828 0"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default GrowDown;
